module.exports = __webpack_public_path__ + "img/dashboard-bg.c650a3b3.png";